import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './api/request.js'
import 'element-ui/lib/theme-chalk/index.css'
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-dark.css'


import { Button, Card, Input, Icon, Form, FormItem ,Upload,Dialog} from 'element-ui'

// axios的配置

Vue.prototype.$http = axios

Vue.config.productionTip = false


Vue.config.ignoredElements = [...Vue.config.ignoredElements, 'wx-open-launch-weapp']


Vue.directive('highlight', (el) => {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
      hljs.highlightBlock(block)
  })
})

Vue.use(Button)
Vue.use(Card)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Upload)
Vue.use(Dialog)




new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
